import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A10.26,10.26,0,0,0,1.75,10.25a10.15,10.15,0,0,0,3,7.24v3.76a2.75,2.75,0,0,0,5,1.58,2.75,2.75,0,0,0,4.5,0,2.75,2.75,0,0,0,5-1.58V17.49a10.15,10.15,0,0,0,3-7.24A10.26,10.26,0,0,0,12,0Zm2.25,10.25A2.25,2.25,0,1,1,16.5,12.5,2.25,2.25,0,0,1,14.25,10.25Zm-.5,6.87a.25.25,0,0,1-.22.13H10.47a.25.25,0,0,1-.22-.13.24.24,0,0,1,0-.26l1.53-2.3a.26.26,0,0,1,.42,0l1.53,2.3A.24.24,0,0,1,13.75,17.12Zm-8.5-6.87A2.25,2.25,0,1,1,7.5,12.5,2.25,2.25,0,0,1,5.25,10.25Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }